import {randomId}    from "../../utils/random";
import {waitTimeout} from "../../utils/wait-timeout";

// let fb_social_connected = false;
let fb_social_connected = true;

export const dev_823 = () => fb_social_connected = !fb_social_connected;

export const MockNextSocialApis = () => ({

    getSocialMediaStatus: async () => ({
        facebook: true,
        instagram: true,
        twitter: true,
        linkedin: true,
    }),
    getFbSocial: async () => {
        // await waitTimeout(50000);
        return !fb_social_connected ? {
            "action": false,
            "error": "We could not access your Facebook pages. Please re-link your account and try again.",
            "login_url": "https://www.facebook.com/v17.0/dialog/oauth?client_id=319825462259732&state=7ce0f22e8c05338dffac6e6781825e93&response_type=code&sdk=php-sdk-5.7.0&redirect_uri=https%3A%2F%2Fproj-33485.awsdev.xpressdocs.com%2Fnext%2Faccount%2Fsocial_connect2.php&scope=business_management%2Cinstagram_basic%2Cinstagram_content_publish%2Cemail%2Cuser_link%2Cpages_read_engagement%2Cpages_show_list%2Cpages_manage_ads%2Cpages_manage_metadata%2Cpages_read_user_content%2Cpages_manage_posts%2Cpages_manage_engagement%2Cpublic_profile"
        } : {
            action: true,
            // action: false,
            data: {
                ig_account: true,
                fb_account: {
                    id: 348,
                    "name": "Testing",
                    login_url: "http://aaa.com",
                    "picture": "https://scontent.fhph1-2.fna.fbcdn.net/v/t39.2365-6/20628602_1941926222743618_7720719376923492352_n.png?_nc_cat=108&_nc_sid=ad8a9d&_nc_ohc=6OUCtBfM_VQAX_VQZ7L&_nc_ht=scontent.fhph1-2.fna&oh=d9780f05b18186c4640f7cde4af2559d&oe=5F59F01D",
                },
                fb_pages: [
                    {
                        id: 111, name: "Test FB Page 1",
                        "picture": "https://scontent.fhph1-2.fna.fbcdn.net/v/t39.2365-6/20628602_1941926222743618_7720719376923492352_n.png?_nc_cat=108&_nc_sid=ad8a9d&_nc_ohc=6OUCtBfM_VQAX_VQZ7L&_nc_ht=scontent.fhph1-2.fna&oh=d9780f05b18186c4640f7cde4af2559d&oe=5F59F01D",
                    },
                    {
                        id: 222, name: "Test FB Page 2",
                        "picture": "https://scontent.fhph1-2.fna.fbcdn.net/v/t39.2365-6/20628602_1941926222743618_7720719376923492352_n.png?_nc_cat=108&_nc_sid=ad8a9d&_nc_ohc=6OUCtBfM_VQAX_VQZ7L&_nc_ht=scontent.fhph1-2.fna&oh=d9780f05b18186c4640f7cde4af2559d&oe=5F59F01D",
                    },
                ],
            },
        };
    },
    getTwSocial: async () => ({
        action: true,
        // action: false,
        tw_account: {
            id: 222,
            "name": "Testing",
            "picture": "https://scontent.fhph1-2.fna.fbcdn.net/v/t39.2365-6/20628602_1941926222743618_7720719376923492352_n.png?_nc_cat=108&_nc_sid=ad8a9d&_nc_ohc=6OUCtBfM_VQAX_VQZ7L&_nc_ht=scontent.fhph1-2.fna&oh=d9780f05b18186c4640f7cde4af2559d&oe=5F59F01D",
        },
    }),
    getLiSocial: async () => ({
        // "action": false,
        "action": true,
        "li_account": {
            id: 534,
            // "action": true,
            "action": false,
            "login_url": "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78742cy21ml8hg&redirect_uri=https://proj-26758.awsdev.xpressdocs.com/next/account/social_connect2.php&scope=r_emailaddress,r_liteprofile,w_member_social&state=eyJpZCI6ImFyNzhIMjBZZ0wiLCJ0eXBlIjoibGlua2VkaW4iLCJyZWRpcmVjdCI6Imh0dHBzOlwvXC9wcm9qLTI2NzU4LmF3c2Rldi54cHJlc3Nkb2NzLmNvbVwvYXBwXC9jdXN0b21pemVcL29yZGVyXC8xMzc0MTEwOSIsInNoYXJlX2xvY2F0aW9uIjoieHByZXNzbyIsImVudGl0eV90eXBlIjoiQWdlbnQiLCJpZF9lbnRpdHkiOiIzNzhiNDg1ZjA4In0=",
            "error": "LinkedIn login failed. Please relink your account and try again.",
            // shouldRelink: true,
        },
    }),
    removeLiSocial: async () => {
        console.log("removeLiSocial");
    },
    getPiSocial: async () => null,



    ...(() => {
        const sharePage = async () => {
            await waitTimeout(500);
            return {
                // action
                // action: true,

                action: false,
                // data,
                page_info: randomId(),
                // data: "Share Failed. This post has already been shared to this account and cannot be reshared. Please change messaging for post and try again.",
                error: "Share Failed. This post has already been shared to this account and cannot be reshared. Please change messaging for post and try again.",
            };
        };
        return {
            shareFbPage: sharePage,
            shareIgPage: sharePage,
            shareLiPage: sharePage,
            shareTwPage: sharePage,
        };
    })(),
    removeFbSocial: () => {},

    socialPostV2: async () => {
        await waitTimeout(500);
        return ({

            // SUCCESS
            // action: true,
            // socialId: "123",     //Id of the user on the social site
            // postId: "123",     //id of the post in social media
            // post: {},       //Post object received from social site,
            // ///////////////////////////////////////////dependent on which social media platform
            // page_info: "123",  //not guaranteed but would have the name of the page if it was facebook/instagram
            // published_item: "123",  //Linkedin iframe,

            action: false,
            error: "Share Failed. This post has already been shared to this account and cannot be reshared. Please change messaging for post and try again.",
            post: {},   //not guaranteed  but may have what ever the failed post was
        });
    },


    requestFbBusinessPageLink: async ({pageId, agentId}) => {

        console.log("API /next-api/social/request_client_page", {pageId, agentId});
        // /next-api/social/request_client_page
        // {"idEntity":"92d89385","entityType":"Agent", "pageId":"108368705336853"}
        await waitTimeout(50);

        // request, pending, granted
        // {status: "granted"} ( new response format Aug 29 )
        return {
            // "status":"granted", // "pending" | "rejected"
            "status": !dev_fb_business_page_linked ? "pending" : "granted",
        };
    },


    // getFbBusinessPageStatus: () => {
    //     // /next-api/social/get_client_page_status
    //     // {"idEntity":"92d89385","entityType":"Agent", "pageId":"108368705336853"}
    //     return {
    //         "action": true,
    //         "status": dev_fb_business_page_linked ? "rejected" : "pending", // "granted" | "pending" | "rejected"?
    //     };
    // },

    getFbBusinessPageClientApprovalUrl: async ({}) => {
        // /next-api/social/get_client_approval_url
        // {"idEntity":"92d89385","entityType":"Agent", "businessId":"403217548552365"}
        await waitTimeout(30);
        return {
            "action": true,
            "result": "https://business.facebook.com/settings/requests?business_id=403217548552365"
        };
    },
    getFbPages: async ({agentId}) => {
        console.log("API getFbPages");
        // await waitTimeout(500);
        // /next-api/social/get_social_pages/{entityType}/{idEntity}
        // params: idEntity = 92d89385 entityType= Agent
        return [
            {
                "socialsiteLinkedAccountId": 20288,
                "socialsitePageName": "Samplefbpage",
                "socialsitePageDesc": "{\"about\":\"\",\"type\":\"personal\",\"business_id\":\"\",\"XD_linked\":false}",
                "socialsitePageAccessToken": "EAAEi4SsRcBQBOyZCkwzHZA7QTyUmDSN46oxA8dCrKsmxgsA0Ds6tFx6yXd28bto1ZCwBjxHbKnsQt1BGvXoP3xXmcD3ZAS1Xrke9SDt6biZBgGEGxRWgQ7Bk3beCwSkqHbNZCIrsayvapu34fq7j4RFs712UmVbtJ93OfItZBDOLEctcIl63ovBhFdoZAynUbIkv"
            },
            {
                "socialsiteLinkedAccountId": 20288,
                "socialsitePageName": "Fb to ig",
                "socialsitePageDesc": "{\"about\":\"\",\"type\":\"personal\",\"business_id\":\"\",\"XD_linked\":false}",
                "socialsitePageAccessToken": "EAAEi4SsRcBQBO8jf5LewDrij0K5OiMGm6xoU3cDGEJl9FEgZBurQCWTPhW5g1tRZBt2BMsY6JznjI1dL90Xhr3KGNOQbIwt2ShqKE6MPfvdNvjU1DCzpJ2T5WeVxLLvVUMFwkAcGaS4jCJZAnqvavUQ2CwDMFi0QhldbgT9D5fVkZAPJxqyGSD7MsYGvF3QZD"
            },
            {
                "socialsiteLinkedAccountId": 20288,
                "socialsitePageName": "Hello World",
                "socialsitePageDesc": "{\"about\":\"\",\"type\":\"personal\",\"business_id\":\"\",\"XD_linked\":false}",
                "socialsitePageAccessToken": "EAAEi4SsRcBQBOzwjtzm1He0ZALofgoC2PjR1PU0kqQlknsz542yB6Q0ZBsQsmBtaWw24zkZAZAx5pcf9UEPFFxPN195yblh4VyalwXfDS76WzFj4H0w7ysgdLYhdBrZBaFz54S2wdj7XcBAZBYHEnzHYfrQh5FGdcoO6NiWHYUDqZBF6d8yKJQuroVGjLd6nQ4ZD"
            },
            {
                "socialsiteLinkedAccountId": 20288,
                "socialsitePageName": "My test page",
                "socialsitePageDesc": JSON.stringify({
                    about: "",
                    type: "business",
                    page_id: 403217548552365,
                    XD_linked: dev_fb_business_page_linked,
                    // XD_linked: true,
                }),
                "socialsitePageAccessToken": "EAAEi4SsRcBQBOy7NxrVtGTJqmSlDd963TnDxE0TlZCFy7RRVRDFagyyWBaZBQ8xo2QXkZBxzWc5bbXCIJOVPu88VwyxRj9PMO4QB5I2FrFAgiaYwA0fZA28Y12XnDTAnnVBk9PbSgmSCegFZAtgw8L8VW95zfbTi4cJpZCSQiQrboA3C76T1KM1wZAqUUY9JsAZD"
            },
            // {
            //     "socialsiteLinkedAccountId": 20288,
            //     "socialsitePageName": "My test page",
            //     "socialsitePageDesc": JSON.stringify({
            //         about: "",
            //         type: "business",
            //         business_id: 2222,
            //         // XD_linked: false,
            //         XD_linked: true,
            //     }),
            //     "socialsitePageAccessToken": "EAAEi4SsRcBQBOy7NxrVtGTJqmSlDd963TnDxE0TlZCFy7RRVRDFagyyWBaZBQ8xo2QXkZBxzWc5bbXCIJOVPu88VwyxRj9PMO4QB5I2FrFAgiaYwA0fZA28Y12XnDTAnnVBk9PbSgmSCegFZAtgw8L8VW95zfbTi4cJpZCSQiQrboA3C76T1KM1wZAqUUY9JsAZD"
            // },
        ];
    },
});

// let dev_fb_business_page_linked = true;
let dev_fb_business_page_linked = false;
export const dev_37j = () => dev_fb_business_page_linked = !dev_fb_business_page_linked;

